import React from 'react';
import { Link } from 'react-router-dom';
import skillImage from '../../assets/brand/skill.png';

interface BlogNewsletterBannerProps {
  title: string;
  description: string;
  titleSize?: string;
  mobileTitleLines?: string[];
  descriptionMaxWidthClass?: string;
}

const BlogNewsletterBanner: React.FC<BlogNewsletterBannerProps> = ({
  title,
  description,
  titleSize = '28px',
  mobileTitleLines,
  descriptionMaxWidthClass = 'max-w-[360px]',
}) => {
  return (
    <div className="layout-container py-6 lg:py-10">
      <section
        className="w-full relative flex flex-col lg:flex-row items-stretch overflow-hidden bg-brand-purple rounded-[24px]"
      >
        <div className="px-6 py-8 lg:px-10 lg:py-10 lg:w-[60%] relative z-10 flex-shrink-0">
          <h3
            className="font-title font-semibold text-white leading-[1.15]"
            style={{ fontSize: titleSize }}
          >
            {mobileTitleLines && mobileTitleLines.length > 0 ? (
              <span className="block sm:hidden">
                {mobileTitleLines.map((line, index) => (
                  <span key={`${line}-${index}`} className="block">
                    {line}
                  </span>
                ))}
              </span>
            ) : null}
            <span className={mobileTitleLines && mobileTitleLines.length > 0 ? 'hidden sm:block' : 'block'}>
              {title}
            </span>
          </h3>
          <p className={`mt-3 font-description text-[13px] md:text-[14px] font-light leading-[1.5] text-white/90 ${descriptionMaxWidthClass}`}>
            {description}
          </p>

          <div className="mt-5">
            <Link
              to="/contact?subject=Book%20a%20Consultation"
              className="inline-flex px-5 py-2.5 font-title text-[13px] font-medium text-white bg-white/15 backdrop-blur-md border border-white/30 rounded-full hover:-translate-y-0.5 transition-transform"
            >
              Go to BAO Academy &rarr;
            </Link>
          </div>
        </div>

        <div className="w-full lg:w-[40%] flex-shrink-0 relative overflow-hidden rounded-b-[24px] lg:rounded-b-none lg:rounded-r-[24px] flex items-center justify-center lg:justify-end min-h-[180px]">
          <span className="pointer-events-none absolute right-[-100px] top-1/2 h-[360px] w-[360px] -translate-y-1/2 rounded-full border border-[#FFFFFF40]" />
          <span className="pointer-events-none absolute right-[-70px] top-[45%] h-[400px] w-[360px] -translate-y-1/2 rotate-[8deg] rounded-full border border-[#FFFFFF2E]" />
          <img
            src={skillImage}
            alt="Academy VR"
            className="w-full max-w-[360px] object-contain mix-blend-hard-light opacity-80 scale-[1.05] relative z-10"
          />
        </div>
      </section>
    </div>
  );
};

export default BlogNewsletterBanner;
